import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class app_custom_ds_get_grouped_child_orderlines_by_orderId_lineNumberService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { orderId: number, lineNumber: number }): 
  Promise<{ result: { TotalChildrenPackaging?: number, OrderId?: number, ParentLineNumber?: number } }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.lineNumber)) {
      $missingRequiredInParams.push('\'lineNumber\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      orderId: number, lineNumber: number    }) {
        if(isNil($inParams.orderId)) {
          return true; 
        }
        if(isNil($inParams.lineNumber)) {
          return true; 
        }
      return false;
    }
}
